import HbAccount from "./HbAccount"
import HbCart from "./HbCart"
import HbProducts from "./HbProducts"
import { useState, useEffect, useRef } from "react"
import "../Nav.css"

const HamburgerMenu = ({ menuShowing, setMenuShowing }) => {
  const [categories, setCategories] = useState([])
  const menuRef = useRef()

  /* =========================
     FETCH ONCE ONLY
  ========================= */
  useEffect(() => {
    const getCategories = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/categories`)
        const data = await res.json()
        setCategories(data)
      } catch (err) {
        console.error("Category fetch failed", err)
      }
    }

    getCategories()
  }, [])

  /* =========================
     OUTSIDE CLICK (SAFE)
  ========================= */
  useEffect(() => {
    const handleOutsideClick = (e) => {
      // the menu button toggles the menu itself
      if (e.target.closest?.(".hamburger-toggle")) return
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuShowing(false)
      }
    }
    const handleEscape = (e) => {
      if (e.key === "Escape") setMenuShowing(false)
    }

    document.addEventListener("mousedown", handleOutsideClick)
    document.addEventListener("keydown", handleEscape)
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
      document.removeEventListener("keydown", handleEscape)
    }
  }, [setMenuShowing])

  const closeMenu = () => setMenuShowing(false)

  return (
    <ul
      ref={menuRef}
      id="mobile-menu"
      aria-hidden={!menuShowing}
      inert={menuShowing ? undefined : ""}
      className={`HamburgerMenu navbar-nav px-4 pt-3 ${
        menuShowing ? "menu-open" : "menu-closed"
      }`}
    >
      <button
        onClick={closeMenu}
        type="button"
        aria-label="Close menu"
        className="btn-close btn-close-white align-self-end mb-3"
      />

      {/* CENTER WRAPPER */}
      <div className="hb-menu-center">
        <HbProducts closeMenu={closeMenu} />
        <HbAccount closeMenu={closeMenu} />
        <HbCart closeMenu={closeMenu} />
      </div>
    </ul>
  )
}

export default HamburgerMenu
